import { HelperCore } from '@/common/dependencies';
import globalStore from './global';
import { makeAutoObservable, runInAction } from 'mobx';
import { createSlsLogger } from '@public/log/sls';

const slsLogger = createSlsLogger("notice");

class Store {
  permission = false;

  constructor () {
    makeAutoObservable(this);
    this.permission = this.hasPermission();

    if(!HelperCore.IS_PROD){
      window._noticeStore = this;
    }
  }

  hasPermission () {
    if(!window.Notification){
      return false;
    }
    return window.Notification.permission == "granted";
  }

  getPermission () {
    if(this.hasPermission()){
      return Promise.resolve(true);
    }
    if(!window.Notification){
      return Promise.resolve(false);
    }

    return Notification.requestPermission()
      .then(permission => {
        runInAction(() => {
          this.permission = permission == "granted";
        });
        return this.permission;
      })
      .catch(() => false);
  }

  showMessage (message) {
    this.getPermission()
    .then(couldNotice => {
      if(!couldNotice){
        slsLogger.log({
          action : "noPermission",
          ext : JSON.stringify(message),
        });
        return;
      }

      const { title, onClick = () => {}, ...options } = message;
      const notification = new Notification(title, options);
      notification.onclick = event => {
        onClick();
        try{
          notification.close();
        } catch(e){};
      }
    });

  } 
}

const noticeStore = new Store();
export default noticeStore;